<template>
  <v-card flat dense>
    <v-form ref="form" v-model="valid">
      <v-card-title>
        <span class="mr-4">
          {{ $t('ITEM.VIEW') }} {{ (blockTypeById(form.type) || {}).name }}
        </span>
        <v-spacer></v-spacer>

        <v-btn icon @click="cancel">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-subtitle v-if="errorsWithoutForm.length">
        <errors :errors="errorsWithoutForm" />
      </v-card-subtitle>
      <v-card-text>
        <block-form
          v-if="form.id"
          v-model="form"
          :resource="resource"
          :errors="errors.getAll()"
          :action="view"
          :block-type="blockTypeById(form.type)"
          @update-prop="clearErrorByName($event)"
        />
        <v-card-actions>
          <v-btn outlined depressed color="grey" @click="cancel">
            {{ $t('BUTTON.CANCEL') }}
          </v-btn>
          <v-btn depressed color="error" @click="remove">
            {{ $t('BUTTON.DELETE') }}
          </v-btn>
          <confirm-dialog ref="confirm" />
          <v-spacer></v-spacer>
          <v-btn depressed color="primary" :disabled="!valid" @click="update">
            {{ $t('BUTTON.UPDATE') }}
          </v-btn>
        </v-card-actions>
      </v-card-text>
    </v-form>
  </v-card>
</template>

<script>
import errors from '@/modules/_global/mixins/errors';
import Errors from '@/modules/_global/_components/Errors';
import { EDIT } from '@/modules/_global/mixins/form-editable.js';
import BlockForm from '@/modules/booking_blocks/components/forms/BlockForm.vue';
import { BlocksService } from '@/services/reservations/blocks.service';
import blockTypes from '@/modules/booking_schedule/mixins/block-types';
import ConfirmDialog from '@/modules/_global/_components/ConfirmDialog.vue';
import { dateFormatBackend } from '@/modules/_global/filters';

export default {
  name: 'ViewBlock',

  components: {
    ConfirmDialog,
    BlockForm,
    Errors
  },

  mixins: [errors, blockTypes],

  props: {
    id: {
      type: Number,
      required: true
    },
    resource: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      valid: false,
      form: {},
      view: EDIT
    };
  },

  computed: {
    errorsWithoutForm() {
      return ['resource_id', '_unexpected']
        .reduce((acc, i) => acc.concat(this.errors.get(i)), [])
        .filter(i => i);
    }
  },

  mounted() {
    BlocksService.getById(this.id)
      .then(({ data }) => {
        this.form = {
          ...data,
          date_from: dateFormatBackend(data.date_from),
          date_to: dateFormatBackend(data.date_to),
          created_at: dateFormatBackend(data.created_at),
          type: data.resource_type
        };
      })
      .catch(console.error);
  },

  methods: {
    cancel() {
      this.$emit('cancel');
    },

    update() {
      BlocksService.update(this.id, this.form)
        .then(({ data }) => {
          this.$emit('updated', data);
        })
        .catch(this.handleErrors);
    },

    remove() {
      this.$refs.confirm
        .open(this.$t('MESSAGE.REALLY_WANT_TO_REMOVE'), null, {
          cancelBtnText: this.$t('BUTTON.CANCEL'),
          agreeBtnText: this.$t('BUTTON.DELETE'),
          agreeBtnColor: 'error'
        })
        .then(confirm => {
          if (confirm) {
            BlocksService.remove(this.id).then(({ data }) => {
              this.$emit('updated');
            });
          }
        });
    }
  }
};
</script>
